<template>
  <div>
    <v-dialog
      v-model="addUserDialog"
      max-width="1000px"
      content-class="showOverflow"
    >
      <v-container fluid class="pa-0 ma-0">
        <user-create 
          dialog 
          simple
          @on-user-added="userAdded"
          @on-close="addUserDialog = false" 
          :agent-id="agentId"
        />
      </v-container>
    </v-dialog>

    <v-autocomplete
      :value="user"
      :loading="searching"
      :items="users"
      :search-input.sync="search"
      :filter="() => true"
      outlined
      hide-details
      :label="label"
      return-object
      item-text="full_name"
      item-value="id"
      dense
      @input="update"
      :clearable="clearable"
    >
      <template v-slot:item="{ item }">
        <div>
          <div>{{ item.full_name }}</div>
          <div class="caption grey--text">{{ item.email }}</div>
        </div>
      </template>

      <template v-slot:append-item v-if="!disableNew">
        <div class="text-center">
          <v-divider />
          <v-btn small block text color="primary" class="mt-1" @click="addUserDialog = true">Add New</v-btn>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import UserCreate from '@/views/users/Create'

export default {
  name: 'UserSearchField',
  components: {
    UserCreate
  },
  props: {
    user: {
      default: function() {
        return {}
      }
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'user'
    },
    clearable: Boolean,
    disableNew: Boolean,
    agentId: [String, Number]
  },
  data () {
    return {
      searching: false,
      users: [],
      search: null,
      searchTimeout: null,

      addUserDialog: false
    }
  },
  mounted () {
    if(this.user && this.user.id) {
      this.users = [ this.user ]
    } else {
      this.getDataFromApi()
    }
  },
  watch: {
    search () {
      let ref = this
      if(this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(function() {
        ref.getDataFromApi()
      }, 300)
    },
    user (val) {
      if(val && val.id) {
        if(!this.users || !this.users.length) {
          this.users = [ this.user ]
        } else {
          if(!this.users.filter(u => u.id == val.id).length) this.users.push(val)
        }
      }
    }
  },
  methods: {
    setUser(user) {
      this.user = user
      this.users = [ user ]
    },
    getDataFromApi() {
      let queryParams = []
      let expansions = ['e']
      
      if(this.type == 'agent') {
        queryParams.push('f[e.id][not_null]=')
      } else if(this.type == 'both') {
        //Do Nothing
      } else {
        queryParams.push('f[e.id][null]=')
        queryParams.push('f[agent_id]=' + (this.agentId || this.$store.getters.user.id))
      }

      queryParams.push('expand=' + expansions.join(','))

      this.searching = true
      if(this.search) queryParams.push('s=' + encodeURIComponent(this.search)) 

      this.$http.get('users?' + queryParams.join('&'))
        .then(response => {
          this.users = response.data.items
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Error loading users', 'error')
        })
        .finally(() => {
          this.searching = false
        })
    },
    userAdded (data) {
      console.log(data)
      this.$emit('update:user', data.user)
      this.$emit('on-user-added', data)
    },
    update (e) {
      if(e) {
        this.$emit('update:user',e)
      } else {
        this.$emit('update:user', null)
      }
    }
  }
}
</script>